import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import { Link } from 'react-router-dom';

// components
import Grid from '@material-ui/core/Grid';
// import Breadcrumbs from '@material-ui/core/Breadcrumbs';
// import Container from '@material-ui/core/Container';
// import Modal from '@material-ui/core/Modal';
// import AddEditEvent from './components/AddEditEvent';
import Typography from 'components/shared/Typography';
// import LoadingButton from 'components/shared/LoadingButton';
// import Calendar from './components/Calendar';
// import CircularProgress from '@material-ui/core/CircularProgress';
import { SPACING_THIRD, SPACING, SPACING_HALF, SPACING_LEAST } from 'constants/spacing';
import RectangularGrid from 'components/shared/RectangularGrid';
import { Link } from '@material-ui/core';

// hooks
// import { useAllEvents, useCreateEvent, useUpdateEvent } from 'hooks/event';
// import { useDivisionValue } from 'providers/DivisionProvider';

// utils
// import { arrayUniqueKey } from 'utils';

//assets
import branchesImage from 'assets/images/customer/branches.png';
import emptyCheckImage from 'assets/images/customer/emptyCheck.png';
import checkedImage from 'assets/images/customer/checked.png';
import LoadingButton from 'components/shared/LoadingButton';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // minHeight: '100vh',
    minHeight: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftPanel: {
    width: '100%',
    // minHeight: '100vh',
    minHeight: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  form: {
    width: '100%',
  },
  buttonWraper: {
    marginTop: theme.spacing(SPACING),
    bottom: '0',
    position: 'relative',
  },
  monkey: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  phoneInput: {
    '& .MuiInputBase-input::placeholder': {
      textAlign: 'center',
    },
    '& .MuiInputBase-input': {
      textAlign: 'right',
      direction: 'rtl',
    },
  },
  largeLabel: {
    marginTop: 15,
    fontSize: theme.typography.pxToRem(25),
    height: '75%',
    '&:disabled':{
      color: '#959595'
    }
  },
  wholepage: {
    width: '100vw',
    height: '100vh',
    backgroundColor: '#e5e5e5',
  },
  mainContainer: {
    backgroundColor: '#f5f5f5',
    // borderRadius:"10px",
    position: 'relative',
    top: '15%',
    padding: '0px',

    [theme.breakpoints.down('xs')]: {
      backgroundColor: '#e5e5e5',
      top: '0',
    },
  },
  branchCard: {
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: '#D2D2D2',
    borderRadius: '20px',
    marginBottom: '10px',
    [theme.breakpoints.down('xs')]: {
      // marginBottom:"10px",
      // margin: '3%',
    },
  },
  branchCardSelected: {
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: '#24AF6E',
    backgroundColor: '#f1f7f5',
    borderRadius: '20px',
    marginBottom: '10px',

    [theme.breakpoints.down('xs')]: {
      // marginBottom:"10px",
      margin: '3%',
    },
  },
  checkbox: {
    position: 'relative',
    top: '35%',
    width: '50%',
  },
  singleLineText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

function SelectBranch({ selectedBranch, setSelectedBranch, branches_data, nextStep }) {
  const classes = useStyles();
  //   const [selectedBranch, setSelectedBranch] = useState('');
  const onSubmit = (e) => {
    console.log('submit:', e);
    console.log(nextStep);
    nextStep();
  };
  return (
    <Grid container spacing={0} style={{ height: '100%', overflowX: 'hide' }}>
      <Grid item xs={12} md={6} style={{ height: '100%', padding: '3%', overflowY: 'auto' }}>
        <Grid container style={{ alignContent: 'space-between', height: '100%' }}>
          <Grid item xs={12}>
            <Grid container spacing={SPACING_HALF}>
              <Grid
                item
                xs={12}
                style={{ alignContent: 'center', textAlign: 'center', marginTop: '3%' }}
              >
                <Typography variant="h1">انتخاب شعبه</Typography>
              </Grid>
              <Grid item xs={12} style={{ alignContent: 'center', textAlign: 'center' }}>
                <Typography variant="h5" style={{ color: '#838383' }}>
                  لطفا شعبه مورد نظر خود برای مراجعه را انتخاب کنید
                </Typography>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={SPACING_THIRD}
              style={{
                marginTop: '10%',
                justifyContent: 'space-evenly',
                textAlign: 'center',
                padding: '5px',
              }}
            >
              {/* <div className={classes.root}> */}
              {branches_data.map((value, index) => (
                <Grid
                  item
                  xs={12}
                  className={
                    selectedBranch._id === value._id
                      ? classes.branchCardSelected
                      : classes.branchCard
                  }
                  onClick={() => {
                    if (selectedBranch._id === value._id) setSelectedBranch('');
                    else setSelectedBranch(value);
                  }}
                >
                  <Grid container spacing={SPACING_HALF} style={{ height: '100%' }}>
                    <Grid
                      item
                      xs={3}
                      style={{
                        borderLeft: '1px',
                        borderLeftColor: '#D2D2D2',
                        borderLeftStyle: 'solid',
                        padding: '2% 5% 0% 5%',
                        alignContent: 'center',
                        // paddingBottom:0,
                        // paddingTop:"2%"
                      }}
                    >
                      <img src={value.image} alt={value.title} style={{ width: '100%' }}></img>
                    </Grid>

                    <Grid item xs={7}>
                      <Grid
                        container
                        spacing={SPACING_LEAST}
                        style={{
                          padding: '0 5% 0 5%',
                          // height: '75%',
                          alignContent: 'center',
                          textAlign: 'right',
                        }}
                      >
                        <Grid item xs={12}>
                          <Typography variant="h3">{value.title}</Typography>
                        </Grid>
                        <Grid item xs={12} className={classes.singleLineText}>
                          <Typography variant="body">{value.address}</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      style={{
                        // padding: '10%',
                        // height: '75%',
                        alignContent: 'center',
                        // textAlign: 'right',
                      }}
                    >
                      {selectedBranch._id === value._id ? (
                        <img
                          src={checkedImage}
                          alt="notChecked"
                          className={classes.checkbox}
                        />
                      ) : (
                        <img
                          src={emptyCheckImage}
                          alt="notChecked"
                          className={classes.checkbox}
                        />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              ))}
              <Grid item xs={12} style={{ textAlign: 'right', marginTop: '10%' }}>
                <Link
                  variant="h3"
                  href="https://elmabeauty.ir"
                  target="_blank"
                  rel="noopener"
                  style={{ color: '#24AF6E' }}
                >
                  اطلاعات بیشتر در مورد شعب
                </Link>
                <Typography variant="h6" style={{ color: '#838383' }}>
                  موقعیت و آدرس دقیق، ساعات کاری، سرویس‌ها، اپراتورها و ...
                </Typography>
              </Grid>

              {/* </div> */}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid item xs={12} className={classes.buttonWraper}>
              <LoadingButton
                className={classes.largeLabel}
                type="submit"
                // size="small"
                fullWidth
                variant="contained"
                color="primary"
                disabled={selectedBranch === ''}
                onClick={onSubmit}
              >
                مرحله بعد
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6} className={classes.leftPanel}>
        <img src={branchesImage} alt="left" height={'70%'} />
      </Grid>
    </Grid>
  );
}

export default SelectBranch;
